import React from 'react';
import { ArcSkeleton, ArcStack, ArcText } from '@src/core/ui';
import { cardBaseSx } from '../../card-styles';
import type { InfoCardProps } from '../types';

const CARD_SX = {
  ...cardBaseSx,
  borderRadius: 1,
  px: 2,
  py: 1,
} as const;

const InfoCard: React.FC<InfoCardProps> = ({ label, value, isLoading }) => (
  <ArcStack spacing={0.5} sx={CARD_SX}>
    <ArcText.caption fontSize={12}>{label}</ArcText.caption>
    {isLoading ? (
      <ArcSkeleton width='60%' height={24} />
    ) : (
      <ArcText.h4 fontSize={16} fontWeight={600}>{value ?? '—'}</ArcText.h4>
    )}
  </ArcStack>
);

export default InfoCard;
